module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "h8"
    }
  }, [_vm._v("The Limes and Lindrick")])]), _c('a', {
    attrs: {
      "id": "h8"
    }
  }), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "h8"
    }
  }, [_vm._v("The King’s Wood or Roche Wood had yet another ancient name. In the Middle Ages it was always referred to as ‘the wood of Lindrick’. King Henry II’s original charter does not survive, but the monks’ ownership of the wood is mentioned in several confirmations. The earliest of these was issued in 1184, when Pope Urban III confirmed ‘the gift of Lord King Henry II of one hundred acres in Lindric, near the said abbey’. In 1219 Alice, or Adelicia, Countess of Eu, in a deed executed at Tickhill Castle, confirmed the site of the abbey, the grange of Aggecroft, ‘and the wood of Lindric as it is bounded by a ditch’."), _c('sup')]), _c('a', {
    attrs: {
      "id": "fn2-13"
    }
  }), _c('span', {
    attrs: {
      "href": "#/188_notes#fne2-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On 21 January 1232 an ‘inspeximus and confirmation’ of a charter of King Richard I (1189–99) to the monks of Roche Abbey noted the properties in Maltby and Hooton Levitt, followed immediately by ‘the wood of Lindric next to the said abbey, just as the ditch encloses’."), _c('sup', [_c('a', {
    attrs: {
      "id": "fn2-14"
    }
  }), _c('span', {
    attrs: {
      "href": "#/188_notes#fne2-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" The same words appear in a confirmation of 1329. Upon the dissolution of the abbey, the Ministers’ Accounts of 1540 recorded amongst its possessions ‘the wood called Laughton Lyndrek’, estimated at 100 acres, close to the ‘Firth alias Grange Wood’ and Northwood."), _c('sup', [_c('a', {
    attrs: {
      "id": "fn2-15"
    }
  }), _c('span', {
    attrs: {
      "href": "#/188_notes#fne2-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The etymology of Lindrick is thought to be ‘lime-tree ridge’, a compound of an unrecorded word "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ric")]), _vm._v(" with Old English "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("lind")]), _vm._v(" ‘lime-tree’, as in linden, the old name for a lime. Margaret Gelling noted that *"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ric")]), _vm._v(" is not a common place-name element, and that it is liable to be replaced by "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("hrycg")]), _vm._v(" in modern forms."), _c('sup', [_c('a', {
    attrs: {
      "id": "fn2-16"
    }
  }), _c('span', {
    attrs: {
      "href": "#/188_notes#fne2-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" Lindrick or Lindridge names are minor ones that are scattered thinly but widely in different parts of the country. In South Yorkshire and north Nottinghamshire, however, Lindrick is a district name. This is made clear from the name of the village of Carlton-in-Lindrick, just inside the Nottinghamshire border, which is so-called to distinguish it from Carlton-on-Trent, three miles north of Newark. The name means the ‘settlement of the churls’ or free peasants and it can be identified with South Carlton, that part of the village that contains the parish church with its late Anglo-Saxon tower, for Domesday Book also recorded the separate manor of Kingston, now known as North Carlton. The ‘king’s tun’ and the ‘churls’ tun’ probably once formed part of a royal estate. After the Norman Conquest Carlton-in-Lindrick was included within the Honour of Tickhill, which straddled the Yorkshire-Nottinghamshire border; it was recorded as Carlton in Lindric in 1227.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("About 1144 its lord, Ralph de Chevrolcourt, founded a Benedictine nunnery within his park at Wallingwells on the western border of his manor. His foundation grant included the gift of ‘all the woodland of Sicam to be brought into cultivation, which is situate in length from the cultivated land of Rustoch as far as the ditch of Lindrick, and in breadth from the park as far as the assart of Theobald’."), _c('sup', [_c('a', {
    attrs: {
      "id": "fn2-17"
    }
  }), _c('span', {
    attrs: {
      "href": "#/188_notes#fne2-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" These names are lost to us, so the location of the ditch remains elusive, but it seems to be related to the large bite that was taken out of Yorkshire at this point by Wallingwells Park, defined by the Owlands Wood Dike. Another piece of documentary evidence is contained in King Henry II’s confirmation to the Benedictine monks of Blyth Priory, three miles north-east of Carlton and within the Honour of Tickhill, of ‘all their Customs in the wood of `Lindric’, without specifying where this wood lay."), _c('sup', [_c('a', {
    attrs: {
      "id": "fn2-18"
    }
  }), _c('span', {
    attrs: {
      "href": "#/188_notes#fne2-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("No other Lindrick names are recorded in Nottinghamshire; all the rest are from immediately across the South Yorkshire border. A cluster of Lindrick names is found within the township of Anston, which lay within the southern part of the soke and parish of Laughton-en-le-Morthen. Anston Brook winds its way through the deep magnesian limestone gorge of Lindrick Dale, with Anston Stones Wood climbing up the steep slopes on either side. This ancient wood contains numerous native limes. The brook forms the western boundary of Lindrick Common (now a golf course), whose northern limit is marked by Lindrick Hill Farm and Lindrick House. The next settlement to the north is Woodsetts ‘the folds in the wood’, first recorded in 1324."), _c('sup', [_c('a', {
    attrs: {
      "id": "fn2-19"
    }
  }), _c('span', {
    attrs: {
      "href": "#/188_notes#fne2-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" In 1200 King John confirmed a grant to Nycol Salsarius of land in Anston and Dinnington, within the lordship centred on Tickhill Castle, but retained ‘seven bovates of land with appurtenances in Lindrick’."), _c('sup', [_c('a', {
    attrs: {
      "id": "fn2-20"
    }
  }), _c('span', {
    attrs: {
      "href": "#/188_notes#fne2-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" A bovate (or oxgang) varied in size from ten to eighteen acres.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lindrick is also the name of the tranquil part of the medieval town of Tickhill that lies immediately south of the castle. Lindrick House appeared there on Jeffreys’s map of Yorkshire in 1771–72, and Lindrick Villa, Lindrick Square, and Lindrick Lane leading to Woolthwaite are marked on the first edition six-inch Ordnance Survey map of 1855. The Thomas de Lindric, who in the early thirteenth century granted ten acres to Blyth Priory in his furlong within the fields of Tickhill, probably lived here;"), _c('sup', [_c('a', {
    attrs: {
      "id": "fn2-21"
    }
  }), _c('span', {
    attrs: {
      "href": "#/188_notes#fne2-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" likewise the William de Lindric who witnessed a charter of Maud de Lovetot, the former wife of Gerard de Furnival and lady of the manors of Worksop and Sheffield, in the second quarter of the thirteenth century."), _c('sup', [_c('a', {
    attrs: {
      "id": "fn2-22"
    }
  }), _c('span', {
    attrs: {
      "href": "#/188_notes#fne2-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" At the present time, this part of Lindrick lies well inside Yorkshire, for the county boundary follows that of Tickhill parish in the low-lying former marshy area to the east, but it was originally one of several tiny settlements that were situated on the 50-foot contour line around the huge swamp which stretched northwards as far as the Isle of Axholme to form a nearly impassable barrier between Yorkshire and Nottinghamshire. The settlement name suggests that the wider district of Lindrick followed the western edge of this swamp and that Roger de Busli built his Norman castle directly on the border as a matter of deliberate policy. The major part of his new Honour of Tickhill lay in north Nottinghamshire, where Blyth acted as a rival centre at the other side of the swamp. Lindrick remains separated from the rest of Tickhill by a stream known as the Paper Mill Dike, which winds its way east of the castle before flowing northwards into the River Torne near Limpool Farm, a name recorded in 1263 which means ‘lime-tree pool’. The farm stands just inside the Nottinghamshire parish of Harworth, the ‘boundary farm or estate’.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13ccffb4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/20_chapter026.vue
// module id = 117
// module chunks = 0